// Translation for te
export const te = {
        common: {
            save: 'సేవ్ చేయండి',
            cancel: 'రద్దు చేయండి',
            close: 'మూసివేయండి',
            delete: 'తొలగించండి',
            edit: 'సవరించండి',
            activate: 'సక్రియం చేయండి',
            add: 'జోడించండి',
            saving: 'సేవ్ అవుతోంది...',
            loading: 'లోడ్ అవుతోంది...',
            active: 'సక్రియంగా ఉంది',
            inUse: 'వాడుకలో ఉంది',
            test: 'పరీక్ష',
            searchApps: 'యాప్‌లను వెతకండి...',
            betaBanner: 'బీటా - సేవ ఇంకా అందుబాటులో లేదు!'
        },
        header: {
            creditBalance: 'బ్యాలెన్స్',
            minutes: 'నిమిషాలు'
        },
        auth: {
            signIn: 'సైన్ ఇన్',
            signUp: 'సైన్ అప్',
            username: 'వినియోగదారు పేరు',
            password: 'పాస్‌వర్డ్',
            continue: 'కొనసాగించండి',
            noAccount: 'ఖాతా లేదా?',
            hasAccount: 'ఇప్పటికే ఖాతా ఉందా?',
            loginError: 'లాగిన్ విఫలమైంది',
            invalidCredentials: 'తప్పు వినియోగదారు పేరు లేదా పాస్‌వర్డ్',
            rateLimited: 'ఎక్కువ లాగిన్ ప్రయత్నాలు. దయచేసి కాసేపు వేచి ఉండండి.',
            sessionExpired: 'మీ సెషన్ ముగిసింది. దయచేసి కొత్త మ్యాజిక్ లింక్‌ను ఉపయోగించండి.',
            magicLinkInvalid: 'లాగిన్ లింక్ చెల్లదు లేదా గడువు ముగిసింది.',
            magicLinkSuccess: 'స్వాగతం! మీరు విజయవంతంగా లాగిన్ అయ్యారు.',
            magicLinkProcessing: 'లాగిన్ ప్రక్రియ జరుగుతోంది...',
            connectionError: 'కనెక్షన్ లోపం. దయచేసి మళ్ళీ ప్రయత్నించండి.'
        },
        profile: {
            myProgress: 'నా అభ్యసన పురోగతి',
            signOut: 'సైన్ అవుట్',
            plan: 'ప్లాన్: '
        },
        settings: {
            title: 'సెట్టింగ్‌లు',
            tabs: {
                uiSettings: 'UI సెట్టింగ్‌లు',
                systemPrompt: 'సిస్టమ్ ప్రాంప్ట్',
                llmProfiles: 'LLM ప్రొఫైల్‌లు',
                ttsProfiles: 'TTS ప్రొఫైల్‌లు',
                language: 'భాష',
            },
            uiSettings: {
                title: 'యూజర్ ఇంటర్‌ఫేస్',
                themeMode: 'థీమ్ మోడ్',
                darkMode: 'డార్క్ మోడ్',
                lightMode: 'లైట్ మోడ్',
                themeColor: 'థీమ్ రంగు',
                themeColorDesc: 'బటన్లు, చిహ్నాలు మరియు హైలైట్‌ల కోసం యాక్సెంట్ రంగును ఎంచుకోండి',
                background: 'నేపథ్యం',
                backgroundDesc: 'మీ వర్క్‌స్పేస్ కోసం ఒక నేపథ్యాన్ని ఎంచుకోండి',
                selectBackgroundColor: 'నేపథ్య రంగును ఎంచుకోండి',
                backgrounds: {
                    cyberSchooling: 'సైబర్ స్కూలింగ్',
                    focus: 'ఫోకస్',
                    concentration: 'ఏకాగ్రత',
                    relaxation: 'విశ్రాంతి',
                    lianas: 'లియానాస్',
                    color: 'రంగు'
                },
                backgroundColors: {
                    deepDark: 'గాఢమైన నలుపు',
                    darkGrey: 'ముదురు బూడిద',
                    midnightBlue: 'మిడ్నైట్ బ్లూ',
                    indigo: 'ఇండిగో',
                    darkTeal: 'ముదురు టీల్',
                    brown: 'గోధుమ రంగు',
                    darkRed: 'ముదురు ఎరుపు',
                    deepPurple: 'ముదురు ఊదా',
                    pureWhite: 'స్వచ్ఛమైన తెలుపు',
                    softWhite: 'మృదువైన తెలుపు',
                    lightGrey: 'లేత బూడిద',
                    paleBlue: 'లేత నీలం',
                    paleGreen: 'లేత ఆకుపచ్చ',
                    paleOrange: 'లేత నారింజ',
                    lavender: 'లావెండర్',
                    blueGrey: 'బ్లూ గ్రే'
                }
            },
            systemPrompt: {
                label: 'సిస్టమ్ ప్రాంప్ట్:',
                placeholder: 'సిస్టమ్ ప్రాంప్ట్ లోడ్ అవుతోంది...',
                emptyError: 'సిస్టమ్ ప్రాంప్ట్ ఖాళీగా ఉండకూడదు!',
                saveSuccess: '✓ సిస్టమ్ ప్రాంప్ట్ విజయవంతంగా సేవ్ చేయబడింది!',
                loadError: 'సిస్టమ్ ప్రాంప్ట్ లోడ్ చేయడంలో లోపం',
                saveError: 'సేవ్ చేయడంలో లోపం'
            },
            llmProfiles: {
                addButton: '+ కొత్త కనెక్షన్‌ను జోడించు',
                newConnection: 'కొత్త కనెక్షన్',
                editConnection: 'కనెక్షన్‌ను సవరించు',
                emptyState: 'LLM కనెక్షన్‌లు అందుబాటులో లేవు. జోడించడానికి క్రింద క్లిక్ చేయండి.',
                loadingProfiles: 'ప్రొఫైల్‌లు లోడ్ అవుతున్నాయి...',
                nameLabel: 'పేరు *',
                namePlaceholder: 'ఉదా. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API కీ *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'మోడల్ *',
                modelPlaceholder: 'gpt-4, mistral-tiny మొదలైనవి.',
                allFieldsRequired: 'అన్ని ఫీల్డ్‌లు తప్పనిసరిగా పూరించాలి!',
                saveSuccess: '✓ ప్రొఫైల్ విజయవంతంగా సేవ్ చేయబడింది!',
                deleteConfirm: 'మీరు నిజంగా "{name}"ని తొలగించాలనుకుంటున్నారా?',
                profileNotFound: 'ప్రొఫైల్ కనుగొనబడలేదు!',
                loadError: 'ప్రొఫైల్‌లను లోడ్ చేయడంలో లోపం',
                saveError: 'సేవ్ చేయడంలో లోపం',
                activateError: 'సక్రియం చేయడంలో లోపం',
                deleteError: 'తొలగించడంలో లోపం',
                modelInfo: 'మోడల్: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ కొత్త వాయిస్‌ని జోడించు',
                newVoice: 'కొత్త వాయిస్',
                editVoice: 'వాయిస్‌ని సవరించు',
                emptyState: 'TTS ప్రొఫైల్‌లు అందుబాటులో లేవు. జోడించడానికి క్రింద క్లిక్ చేయండి.',
                loadingProfiles: 'TTS ప్రొఫైల్‌లు లోడ్ అవుతున్నాయి...',
                nameLabel: 'పేరు',
                namePlaceholder: 'ఉదా. నా ElevenLabs ఆడమ్',
                providerLabel: 'ప్రొవైడర్',
                providerPlaceholder: 'ఉదా. ElevenLabs, OpenAI, Piper',
                providerPiper: 'పైపర్ (లోకల్)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API కీ *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'మోడల్ ID *',
                modelIdPlaceholder: 'ఉదా. eleven_monolingual_v1',
                voiceIdLabel: 'వాయిస్ ID',
                voiceIdPlaceholder: 'ఉదా. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'అన్ని ఫీల్డ్‌లు తప్పనిసరిగా పూరించాలి!',
                saveSuccess: '✓ TTS ప్రొఫైల్ విజయవంతంగా సేవ్ చేయబడింది!',
                deleteConfirm: 'మీరు నిజంగా "{name}"ని తొలగించాలనుకుంటున్నారా?',
                loadError: 'TTS ప్రొఫైల్‌లను లోడ్ చేయడంలో లోపం',
                saveError: 'సేవ్ చేయడంలో లోపం',
                activateError: 'సక్రియం చేయడంలో లోపం',
                deleteError: 'తొలగించడంలో లోపం'
            },
            language: {
                title: 'భాషను ఎంచుకోండి',
                description: 'యూజర్ ఇంటర్‌ఫేస్ కోసం మీకు నచ్చిన భాషను ఎంచుకోండి'
            },
        },
        chat: {
            ready: 'సిద్ధంగా ఉంది',
            start: 'ప్రారంభించు',
            stop: 'ఆపివేయి',
            initialMessage: 'నిజ-సమయ సంభాషణ కోసం ప్రారంభించు క్లిక్ చేయండి.',
            listening: 'వింటున్నాను...',
            speaking: 'థోర్‌స్టన్ మాట్లాడుతున్నాడు...',
            userLabel: 'మీరు',
            aiLabel: 'AI',
            modalTitle: 'థోర్‌స్టన్ AI చాట్',
            inputPlaceholder: 'సందేశాన్ని టైప్ చేయండి...',
            send: 'పంపించు',
            loginRequired: 'ఈ సేవను ఉపయోగించడానికి దయచేసి సైన్ ఇన్ చేయండి.',
            loginButton: 'ఇప్పుడే సైన్ ఇన్ చేయండి',
            magicLinkRequired: 'సైన్ ఇన్ చేయడానికి దయచేసి మ్యాజిక్ లింక్‌ని ఉపయోగించండి.',
            creditLimitError: 'మీ గంట కోటా ముగిసింది. కొనసాగించడానికి దయచేసి మీ ప్లాన్‌ను (మీడియం/ప్రీమియం) అప్‌గ్రేడ్ చేయండి.',
            serviceDisabled: 'చాట్ సేవ ప్రస్తుతం అందుబాటులో లేదు. దయచేసి తర్వాత మళ్ళీ ప్రయత్నించండి.'
        },
        notifications: {
            error: 'లోపం',
            success: 'విజయం',
            info: 'సమాచారం',
            unknownError: 'తెలియని లోపం సంభవించింది'
        },
        cookie: {
            message: 'మీకు ఉత్తమ వినియోగదారు అనుభవాన్ని అందించడానికి ఈ వెబ్‌సైట్ కుక్కీలను ఉపయోగిస్తుంది.',
            accept: 'అంగీకరిస్తున్నాను'
        },
        curriculum: {
                buttonLabel: 'పాఠ్యాంశం',
                buttonTitle: 'పాఠ్యాంశ విషయాన్ని చూపించు',
                modalTitle: '{app} పాఠ్యాంశం',
                sections: {
                    topic: 'పాఠ్యాంశ అంశం',
                    explanation: 'పిల్లలకు అర్థమయ్యే వివరణ',
                    studentProfile: 'విద్యార్థి ప్రొఫైల్'
                },
                topic: {
                    empty: 'ఈ మైక్రో-యాప్కు బ్యాకెండ్లో ఎటువంటి పాఠ్యాంశ అంశం లింక్ చేయబడలేదు.',
                    missingDetail: 'ఈ మైక్రో-యాప్ కోసం వివరణాత్మక పాఠ్యాంశ డేటా ఇంకా బ్యాకెండ్లో అందుబాటులో లేదు.',
                    learningGoals: 'నేర్చుకునే లక్ష్యాలు',
                    prerequisites: 'ముందస్తు అవసరాలు',
                    unitLabel: 'యూనిట్',
                    durationLabel: 'వ్యవధి',
                    difficultyLabel: 'కష్టతరం స్థాయి',
                    hours: 'గం',
                    minutes: 'ని'
                },
                explanation: {
                    empty: 'పిల్లలకు అర్థమయ్యే వివరణ అందుబాటులో లేదు.',
                    loadingPrepare: 'AI వివరణను సిద్ధం చేస్తోంది',
                    loadingExplain: 'AI పిల్లల భాషలో అంశాన్ని వివరిస్తోంది',
                    requestFailed: 'పిల్లలకు అర్థమయ్యే వివరణను రూపొందించలేకపోయింది.'
                },
                studentProfile: {
                    country: 'దేశం',
                    region: 'రాష్ట్రం / ప్రాంతం',
                    schoolType: 'పాఠశాల రకం',
                    grade: 'తరగతి',
                    noContext: 'విద్యార్థి సందర్భం అందుబాటులో లేదు.',
                    childProfileNotFound: 'ప్రస్తుత లాగిన్ కోసం బ్యాకెండ్లో ఎటువంటి విద్యార్థి ప్రొఫైల్ కనుగొనబడలేదు.',
                    loginProfileIncomplete: 'లాగిన్ ప్రొఫైల్లో ఇంకా పూర్తి విద్యార్థి సందర్భం లేదు.',
                    educationContextNotFound: 'విద్యార్థి ప్రొఫైల్ కనుగొనబడింది, కానీ పాఠ్యాంశ కేటాయింపు సెట్ చేయబడలేదు.',
                    noToken: 'సైన్-ఇన్ చేసిన విద్యార్థి ఎవరూ కనుగొనబడలేదు.'
                },
                errors: {
                    signInRequired: 'పాఠ్యాంశాన్ని వీక్షించడానికి దయచేసి సైన్ ఇన్ చేయండి.',
                    appIdMissing: 'యాప్ ID లేదు.',
                    loadFailed: 'పాఠ్యాంశ డేటాను లోడ్ చేయలేకపోయింది.'
                }
            }
    };
